import React, { Suspense, lazy, useReducer } from 'react';
import PrivateRoute from "../../routes/PrivateRoute";
import PublicRoute from "../../routes/PublicRoute";
import { Spinner } from '../Common/Spinner';
import JourneyProfileList from './List/JourneyProfileList';
import JourneyProfileForm from './List/JourneyProfileForm';
import JourneyReducer from './List/JourneyReducer';
import { JourneyContext, initialJourneyState } from "./List/JourneyContext";
import { useCurrentUserHook } from '../Authentication/useUserHook';
import PortalPage from './PortalPage/PortalPage';
//const EventList = lazy(() => import('./EventList'));

const EventRoute = (props) => {
  const {currentUser} = useCurrentUserHook();
  const [journeyState, journeyDispatch] = useReducer(JourneyReducer, initialJourneyState);

  return (
    <Suspense fallback={<Spinner/>}>
      <JourneyContext.Provider value={{journeyState, journeyDispatch}}>
        <PrivateRoute path="/list/journey" searchString={props.searchString} component={JourneyProfileList} exact />
        <PrivateRoute path="/form/journey/:id?" component={JourneyProfileForm} exact />
        <PrivateRoute path="/journey/portal/page/:journey_profile_id" component={PortalPage} exact />
      </JourneyContext.Provider>
    </Suspense>
  )
}

export default EventRoute;